module.exports = __webpack_public_path__ + "img/jianianhua_img4.92602b66.jpg";